import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { ProjectFinanceTab, ProjectProfitabilityTab } from '@/features/finance';
// Route options read the light search module; the page is code-split with the component.
import { ProjectPage } from '@/features/projects/pages/project-page';
import { DEFAULT_PROJECT_TAB, isProjectTab } from '@/features/projects/search';

/** One project: header and tabs, the open tab being a segment of the address. */
export const Route = createFileRoute('/_auth/o/$orgId/projects/$projectId/$tab')({
  // An unknown tab name falls back to the first tab instead of a dead end.
  beforeLoad: ({ params }) => {
    if (!isProjectTab(params.tab)) {
      redirect({
        to: '/o/$orgId/projects/$projectId/$tab',
        params: { ...params, tab: DEFAULT_PROJECT_TAB },
        replace: true,
        throw: true,
      });
    }
  },
  component: ProjectRoute,
});

function ProjectRoute() {
  const { orgId, projectId, tab } = Route.useParams();
  const navigate = useNavigate();
  return (
    <ProjectPage
      orgId={orgId}
      projectId={projectId}
      renderFinanceTab={(project) => <ProjectFinanceTab orgId={orgId} projectId={project.id} />}
      renderProfitabilityTab={(project) => (
        <ProjectProfitabilityTab orgId={orgId} projectId={project.id} />
      )}
      tab={isProjectTab(tab) ? tab : DEFAULT_PROJECT_TAB}
      onTabChange={(next) => {
        void navigate({
          to: '/o/$orgId/projects/$projectId/$tab',
          params: { orgId, projectId, tab: next },
        });
      }}
    />
  );
}
